import { render, staticRenderFns } from "./TimeTable.vue?vue&type=template&id=96241606"
import script from "./TimeTable.vue?vue&type=script&lang=js"
export * from "./TimeTable.vue?vue&type=script&lang=js"
import style0 from "./TimeTable.vue?vue&type=style&index=0&id=96241606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports